export const SET_NEW_PASSWORD_REQUEST = "SET_NEW_PASSWORD_REQUEST";
export const SET_NEW_PASSWORD_REQUEST_SUCCESS =
  "SET_NEW_PASSWORD_REQUEST_SUCCESS";
export const SET_NEW_PASSWORD_REQUEST_ERROR = "SET_NEW_PASSWORD_REQUEST_ERROR";
